import React from 'react';
import { FormSection } from 'redux-form';

import { Section, DateField, BoxDouble, SelectField, CheckboxField } from 'src/components/Form';
import { DeleteSquare } from 'jbc-front/components/icons';
import { isDateStringFormat } from 'src/utils/CustomValidators';
import { useTranslation } from 'react-i18next';

const EmployeeLeaveOfAbsenceItem = ({ formKey, remove, leaveOfAbsenceReasonTypes }) => {
  const { t } = useTranslation();
  return (
    <div>
      <FormSection name={formKey}>
        <Section title={t('features.Employees.components.EmployeeLeaveOfAbsenceItem.career_break')} icon={<DeleteSquare onClick={remove} />}>
          <BoxDouble>
            <DateField label={t('features.Employees.components.EmployeeLeaveOfAbsenceItem.starting_date_of_career_break')} name="startOn" validate={isDateStringFormat} />
            <DateField label={t('features.Employees.components.EmployeeLeaveOfAbsenceItem.end_date_of_career_break')} name="endOn" validate={isDateStringFormat} />
          </BoxDouble>
          <SelectField label={t('features.Employees.components.EmployeeLeaveOfAbsenceItem.reason_for_career_break')} name="reasonType" options={leaveOfAbsenceReasonTypes} />
          <CheckboxField
            name="isExclusionPayment"
            label={t('features.Employees.components.EmployeeLeaveOfAbsenceItem.If_all_the_subjected_payroll_period_is_within_this_career_break_the_fixed_salary_will_be_set_to_0')}
          />
        </Section>
      </FormSection>
    </div>
  );
};

export default (EmployeeLeaveOfAbsenceItem);
